export default __webpack_public_path__ + "static/media/delete.a640cab5.svg";